
















import { computed, defineComponent } from "@vue/composition-api";
/* types */
export interface Props {
  title: boolean;
  lineClamp: number;
  level: number;
  visual: string;
  color: string;
}
export default defineComponent({
  name: "OccHeading",
  props: {
    level: {
      type: Number,
      validator: (level: number) => {
        return [1, 2, 3, 4, 5, 6].includes(level);
      },
      default: 1
    },
    visual: {
      type: String,
      default: ""
    },
    color: {
      type: String,
      default: "black"
    },
    lineClamp: {
      type: Number,
      default: 0
    },
    title: {
      type: Boolean,
      default: false
    },
    align: {
      type: String,
      default: ""
    },
    weight: {
      type: String,
      default: ""
    }
  },
  setup(props: Props) {
    const tagLevel = computed(() => {
      return props.title ? `title` : `h${props.level}`;
    });
    const visualLevel = computed(() => {
      return props.visual ? props.visual : props.level;
    });
    const lineClampClassName = computed(() => {
      return props.lineClamp > 0
        ? {
            display: "-webkit-box",
            overflow: "hidden",
            "max-height": "initial",
            "-webkit-line-clamp": `${props.lineClamp}`,
            "-webkit-box-orient": "vertical"
          }
        : {};
    });
    return { tagLevel, visualLevel, lineClampClassName };
  }
});
